@if (this.response().grid.filters.length > 0) {
  <app-filter-component
    [config]="this.displayedFilters()"
    [initialValues]="this.state().filter"
    (filterSubmit)="onFilterData($event)">
  </app-filter-component>
}

@if (this.response().grid.columns.length > 0 || this.response().grid.actions.length > 0 || this.response().grid.options.export) {
  <div class="standalone">
    <div class="col-1">
      <div class="settings-container">
        <button type="button" class="gov-button gov-button--small" (click)="openSettings()" [title]="'sdg.grid.nastaveni_tabulky' | localize">
          <span class="gov-icon gov-icon--settings"></span>
        </button>
      </div>
    </div>
    <div class="col-11">
    @for(action of this.response().grid.actions; track action.url){
      @if (action.visible && action.type === 'standalone'){
        @if (!action.ajax){
          <a 
            [href]="action.url | urlParser : this.state().parameters"
            class="gov-button gov-button--primary"
            [attr.target]="action.urltarget === '_blank' ? '_blank' : null"
          >{{ action.displayname | localize }}</a>
        }
        @else {
          <a href="#" class="gov-button gov-button--primary"
            [attr.data-ajax-url]="action.url | urlParser : this.state().parameters"
            [attr.data-ajax-method]="action.method"
            [attr.target]="action.urltarget === '_blank' ? '_blank' : null"
            (click)="onAjaxActionClick(action, this.state().parameters, $event)"
          >{{ action.displayname | localize }}</a>
        }
      }
    }
    @if (this.response().grid.options.export){
      <a href="#" class="gov-button gov-button--primary"
        (click)="onExportActionClick($event)"
      >{{ "sdg.grid.button.export" | localize }}</a>
    }
    </div>
  </div>
}

<div #tableContainer class="gov-table_overflow" [class.is-scrollable]="isTableScrollable"
  (scroll)="syncScroll(tableContainer, fakeScrollbar)">
  <table #tableElement class="gov-table gov-sortable-table gov-js-sortable-table table-sticky-actions resizable-table"
    [style.width.px]="tableTotalWidth()">
    <thead>
      <tr>
        @if(this.hasMultipleAction()){
          <th class="checkbox-col" [style.width.px]="checkboxColumnWidth">
            <label class="gov-form-control gov-form-control--classic  gov-form-control--custom">
              <input type="checkbox"
                  class="gov-form-control__checkbox"
                  [checked]="isAllSelected()"
                  (change)="toggleAll($any($event.target).checked)" />
              <span class="gov-form-control__indicator"></span>
            </label>
          </th>
        }
        @for (col of this.displayedColumns(); track col.name) {
          @if (col.visible){
            <th class="resizable-col"
            [class.resizing]="resizingColumn() === col.name"
            [title]="col.displayname | localize"
            [style.width.px]="effectiveColumnWidths()[col.name]"
            (click)="onSort(col)"
            >
              <span
                class="gov-sortable-table__trigger"
                [class.current]="this.state().ordercol === col.name"
                [class.gov-sortable-table__trigger--asc]="this.state().orderasc === true && this.state().ordercol === col.name"
                [class.gov-sortable-table__trigger--desc]="this.state().orderasc === false && this.state().ordercol === col.name"
              >{{ col.displayname | localize }}</span>
              <span class="col-resizer"
                title=""
                (mousedown)="onColumnResizeStart($event, col)"
                (click)="$event.stopPropagation()"></span>
            </th>
          }
        }
        @if (hasVisibleSingleAction()){
          <th class="sticky-col" [style.width.px]="actionColumnWidth"></th>
        }
      </tr>
    </thead>
    <tbody class="gov-table__body">
      @for(row of this.data(); track row[this.columnKey()]){
        <tr [class]="this.getCssClassesFromColumns(row)">
            @if(this.hasMultipleAction()){
              <td class="checkbox-col">
                <label class="gov-form-control gov-form-control--classic  gov-form-control--custom">
                  <input type="checkbox"
                      class="gov-form-control__checkbox"
                      [checked]="this.selectedKeys().has(row[this.columnKey()])"
                      (change)="toggleRow(row[this.columnKey()], $any($event.target).checked)"
                      [disabled]="this.rowIsDisabled(row[this.columnKey()])" />
                  <span class="gov-form-control__indicator"></span>
                </label>
              </td>
            }
            @for(col of this.displayedColumns(); track col.name){
              @if (col.visible){
                <td>
                    {{ row[col.name] | dynamicFormat : col }}
                </td>
              }
            }
            @if (hasVisibleSingleAction()){
              <td class="sticky-col sticky-shadow">
                @for (action of this.response().grid.actions; track action.url){
                  @if (action.visible && action.type === 'single' && row[action.visibilitycolumnattr] != 0){
                    @if (action.jsfunction){
                      <a href="#" class="gov-link gov-link--has-arrow"
                        (click)="onJsActionClick(action, row, $event)"
                      >{{ action.displayname | localize }}</a>
                    }
                    @else if (!action.ajax){
                      <a
                        [href]="action.url | urlParser : row : this.state().parameters"
                        class="gov-link gov-link--has-arrow"
                        [attr.target]="action.urltarget === '_blank' ? '_blank' : null"
                      >{{ action.displayname | localize }}</a>
                    }
                    @else {
                      <a href="#" class="gov-link gov-link--has-arrow"
                        [attr.data-ajax-url]="action.url | urlParser : row : this.state().parameters"
                        [attr.data-ajax-method]="action.method"
                        [attr.target]="action.urltarget === '_blank' ? '_blank' : null"
                        (click)="onAjaxActionClick(action, row, $event)"
                      >{{ action.displayname | localize }}</a>
                    }
                  }
                }
              </td>
            }
        </tr>
      }
      @if (!this.data()?.length){
        <tr>
            <td class="grid-empty-message" [attr.colspan]="emptyColspan()">{{ this.noDataMessage() }}</td>
        </tr>
      }
    </tbody>
  </table>
  <app-loader-component [isLoading]="isLoading()"></app-loader-component>
</div>
<div class="floating-scrollbar"
  [class.hidden]="!showFloatingScrollbar"
  [style.left.px]="floatingScrollbarLeft"
  [style.top.px]="floatingScrollbarTop"
  [style.width.px]="floatingScrollbarWidth"
  #fakeScrollbar (scroll)="syncScroll(fakeScrollbar, tableContainer)">
  <div class="dummy-content" [style.width.px]="tableWidth"></div>
</div>
<div class="gov-pagination">
  <div class="gov-pagination__holder">
    <a href="#" class="gov-pagination__item gov-pagination__item--arrow-left"
      [class.gov-pagination__item--disabled]="this.response().page === 0"
      (click)="onPageChange(this.response().page - 1)"
    ></a>
    @for (page of this.visiblePages; track page){
      @if (page < 0) {
        <span class="gov-pagination__item gov-pagination__item--dots">...</span>
      }
      @else {
        <a href="#" class="gov-pagination__item"
          [class.gov-pagination__item--active]="page === this.response().page"
          [class.gov-pagination__item--disabled]="page === this.response().page"
          (click)="onPageChange(page)"
        >{{ page + 1 }}</a>
      }
    }
    <a href="#" class="gov-pagination__item gov-pagination__item--arrow-right"
      [class.gov-pagination__item--disabled]="(this.response().page + 1) === this.response().totalpages"
      (click)="onPageChange(this.response().page + 1)"
    ></a>
  </div>
</div>

@if (this.hasMultipleAction()) {
  <div class="multiple-actions-bar">
      <div
        class="gov-form-control gov-form-control--classic col-12 col-md-5"
        [class.not-empty]="isActionSelected()"
      >
        <div class="gov-select gov-js-select">
          <select id = "multipleactions"
                  [ngModel]="this.selectedActionId()" 
                  (ngModelChange)="selectedActionId.set($event)">
            <option [ngValue]="null" disabled></option>
            @for (action of this.multipleActions(); track action.url) {
              <option [value]="action.displayname">{{ action.displayname | localize }}</option>
            }
          </select>
          <label
            class="gov-form-control__label filterLabel"
            for="multipleActions"
          >{{ 'sdg.grid.selected.items' | localize : this.selectedKeys().size }}</label>
        </div>
      </div>

      <div class="col-12 col-md-2 multiple-action-button-container">
        <button class="gov-button gov-button--primary fill-flex"
                type="button"
                (click)="this.executeMultipleAction()"
                [disabled]="!hasSelection() || !selectedActionId()">
          {{ 'sdg.grid.confirm' | localize}}
        </button>
      </div>
  </div>
}

@if (this.isModalVisible()) {
  <app-confirm-dialog-component
    [message]="pendingAction.action?.confirmation | localize"
    (confirm)="handleAjaxModalResult($event)">
  </app-confirm-dialog-component>
}
